import { observable, action, makeAutoObservable, runInAction } from 'mobx'
import * as Api from '../api'
import AuthManager from '../libs/auth'
import { MobXProviderContext, useLocalObservable } from 'mobx-react';
import React from 'react'
type RoleType = "admin" | 'usr' | 'unknown'


export class Auth {
    @observable userToken = '';
    @observable isAuthed = false;
    @observable usrName = '';
    @observable phoneNumber = '';
    @observable roleType: RoleType = 'unknown';
    @observable loading = false;

    constructor() {
        makeAutoObservable(this)
        AuthManager.Instance().authFail = () => {
            this.isAuthed = false
        }
    }

    @action updateToken = (value: string) => {
        this.userToken = value;
    };

    @action getIsAuthed = () => {
        const token = localStorage.getItem('token')
        if (token) {
            this.updateToken(token)
            this.isAuthed = true
        }

        return this.isAuthed
    };

    @action async authUser(params: { phoneNumber: string; password: string }) {
        // console.log('logging', this.loading)

        // this.loading = true
        let token = await Api.auth.login(params)
        runInAction(() => {
            if (token) {
                this.userToken = token
                this.isAuthed = true
                this.usrName = params.phoneNumber
                this.phoneNumber = params.phoneNumber
                this.roleType = 'admin'
            }
        })
        // this.loading = false

        return
    }

}

const self = new Auth();

export const useAuthStore = (): Auth => {
    const localStore = useLocalObservable(() => self);
    return localStore;
}
export default self;
